import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';
import ConfigPopVideo from './ConfigPopVideo';
import './ConfigRedesSociais.css';

const ConfigRedesSociais = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [config, setConfig] = useState({
    facebook_url: '',
    instagram_url: '',
    youtube_url: '',
    whatsapp_url: '',
    facebook_ativo: false,
    instagram_ativo: false,
    youtube_ativo: false,
    whatsapp_ativo: false
  });
  const [popVideoOpen, setPopVideoOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchConfig();
    }
  }, [isOpen]);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/redes-sociais/config`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data) {
        setConfig({
          facebook_url: response.data.facebook_url || '',
          instagram_url: response.data.instagram_url || '',
          youtube_url: response.data.youtube_url || '',
          whatsapp_url: response.data.whatsapp_url || '',
          facebook_ativo: response.data.facebook_ativo || false,
          instagram_ativo: response.data.instagram_ativo || false,
          youtube_ativo: response.data.youtube_ativo || false,
          whatsapp_ativo: response.data.whatsapp_ativo || false
        });
      }
    } catch (error) {
      console.error('Erro ao buscar configurações:', error);
      setMessage({ type: 'error', text: 'Erro ao carregar configurações' });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage({ type: '', text: '' });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/redes-sociais/config`,
        config,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.status === 200) {
        setMessage({ type: 'success', text: 'Configurações salvas com sucesso!' });
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        throw new Error('Erro ao salvar configurações');
      }
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      const errorMessage = error.response?.data?.error ||
                          error.response?.data?.message ||
                          error.message ||
                          'Erro ao salvar configurações';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setSaving(false);
    }
  };

  const toggleAtivo = (field) => {
    setConfig(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content config-redes-sociais" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Configurações de Redes Sociais</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading">Carregando configurações...</div>
          ) : (
            <>
              {message.text && (
                <div className={`message ${message.type}`}>{message.text}</div>
              )}

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">Facebook</label>
                  <button
                    className={`toggle-button ${config.facebook_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('facebook_ativo')}
                  >
                    {config.facebook_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://www.facebook.com/sua-pagina"
                  value={config.facebook_url}
                  onChange={(e) => setConfig({ ...config, facebook_url: e.target.value })}
                />
              </div>

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">Instagram</label>
                  <button
                    className={`toggle-button ${config.instagram_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('instagram_ativo')}
                  >
                    {config.instagram_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://www.instagram.com/seu-perfil"
                  value={config.instagram_url}
                  onChange={(e) => setConfig({ ...config, instagram_url: e.target.value })}
                />
              </div>

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">YouTube</label>
                  <button
                    className={`toggle-button ${config.youtube_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('youtube_ativo')}
                  >
                    {config.youtube_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://www.youtube.com/c/seu-canal"
                  value={config.youtube_url}
                  onChange={(e) => setConfig({ ...config, youtube_url: e.target.value })}
                />
              </div>

              <div className="config-item">
                <div className="config-item-header">
                  <label className="config-label">WhatsApp</label>
                  <button
                    className={`toggle-button ${config.whatsapp_ativo ? 'ativo' : 'inativo'}`}
                    onClick={() => toggleAtivo('whatsapp_ativo')}
                  >
                    {config.whatsapp_ativo ? 'Ativo' : 'Inativo'}
                  </button>
                </div>
                <input
                  type="url"
                  className="config-input"
                  placeholder="https://wa.me/5511999999999"
                  value={config.whatsapp_url}
                  onChange={(e) => setConfig({ ...config, whatsapp_url: e.target.value })}
                />
              </div>

              <div className="config-separator">
                <h3>Vídeos Pop-up</h3>
              </div>

              <div className="config-item">
                <button
                  className="btn-save"
                  onClick={() => setPopVideoOpen(true)}
                  style={{ width: '100%' }}
                >
                  Configurar Vídeos Pop-up
                </button>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancelar</button>
          <button className="btn-save" onClick={handleSave} disabled={saving || loading}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>

      {popVideoOpen && (
        <ConfigPopVideo
          isOpen={popVideoOpen}
          onClose={() => setPopVideoOpen(false)}
        />
      )}
    </div>
  );
};

export default ConfigRedesSociais;
